export class JobProgressStepVolumeDataBackupData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "blockOnly",
            "baseName": "blockOnly",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "changedBlockMode",
            "baseName": "changedBlockMode",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "volumeCount",
            "baseName": "volumeCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "allocatedBytes",
            "baseName": "allocatedBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "isFullBackup",
            "baseName": "isFullBackup",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "parallelNodeCount",
            "baseName": "parallelNodeCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "nodeAttempts",
            "baseName": "nodeAttempts",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "mountFallback",
            "baseName": "mountFallback",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sourceSizeBytes",
            "baseName": "sourceSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "platform",
            "baseName": "platform",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepVolumeDataBackupData.attributeTypeMap;
    }
    constructor() {
    }
}
